export default "__VITE_ASSET__BNNGBzRc__"